<script setup lang="ts" name="CookiePolicyHeading">
import { RouterLink } from 'vue-router';
</script>

<template>
  <div class="space-y-6">
    <h1 class="text-4xl font-bold">Cookie Policy for MyG2</h1>
    <p>
      This is the Cookie Policy for MyG2, accessible from
      <RouterLink to="/login" class="text-primary-8"> MyG2 </RouterLink>
    </p>
  </div>
</template>
